import { Controller } from "@hotwired/stimulus"

// Submits the form shortly after the user stops typing, or immediately on change.
// Used for the search/filter forms that live inside turbo-frames.
export default class extends Controller {
  static values = { delay: { type: Number, default: 300 } }

  submit() {
    clearTimeout(this.timeout)
    this.timeout = setTimeout(() => this.element.requestSubmit(), this.delayValue)
  }

  disconnect() {
    clearTimeout(this.timeout)
  }
}
